import React, { useState } from "react";

const InvoiceCell = ({
    invoice,
    buttonHidden,
    buttonItemSelected_,
}) => {
    const [showMenu, setShowMenu] = useState(false);

    const style = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '12px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            marginBottom: '8px',
            border: '1px solid #e9ecef',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            position: 'relative'
        },
        invoiceInfo: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1
        },
        invoiceId: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333333',
            marginBottom: '4px'
        },
        invoiceStatus: {
            fontSize: '12px',
            color: '#666666'
        },
        menuButton: {
            padding: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#666666',
            transition: 'all 0.2s ease'
        },
        menuButtonHover: {
            backgroundColor: '#f8f9fa',
            color: '#333333'
        },
        dropdown: {
            position: 'absolute',
            top: '100%',
            right: '8px',
            backgroundColor: '#ffffff',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            minWidth: '180px',
            marginTop: '4px'
        },
        dropdownItem: {
            padding: '12px 16px',
            cursor: 'pointer',
            borderBottom: '1px solid #f8f9fa',
            fontSize: '14px',
            color: '#333333',
            transition: 'background-color 0.2s ease'
        },
        dropdownItemHover: {
            backgroundColor: '#f8f9fa'
        },
        dropdownItemLast: {
            borderBottom: 'none'
        },
        statusBadge: {
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 'bold',
            color: 'white'
        },
        createdBadge: {
            backgroundColor: '#28a745'
        },
        pendingBadge: {
            backgroundColor: '#ffc107',
            color: '#333333'
        },
        errorBadge: {
            backgroundColor: '#dc3545'
        }
    };

    const menuOptions = [
        // { id: 'view-details', label: 'Ver Detalles', icon: '👁️' },
        { id: 'download-pdf', label: 'Descargar PDF', icon: '📄' },
        { id: 'view-in-holded', label: 'Ver factura en Holded', icon: '📄' }
    ];

    const handleMenuItemClick = (option) => {
        setShowMenu(false);
        if (buttonItemSelected_) {
            buttonItemSelected_(option);
        }
    };
    const getStatusBadge = (status) => {
        let time = new Date().getTime() / 1000
        if (invoice.dueDate < time) {
            return (
                <span style={{ ...style.statusBadge, ...style.errorBadge }}>
                    Vencida
                </span>
            )
        }
        switch (status) {
            case 0:

                return (
                    <span style={{ ...style.statusBadge, ...style.pendingBadge }}>
                        No Pagada
                    </span>
                );
            case 1:
                return (
                    <span style={{ ...style.statusBadge, ...style.createdBadge }}>
                        Pagada
                    </span>
                );
            case 2:
                return (
                    <span style={{ ...style.statusBadge, ...style.pendingBadge }}>
                        Pagada parcialmente
                    </span>
                );
            default:
                return null
        }
    };
    const handleClickOutside = (e) => {
        if (!e.target.closest('.invoice-menu-container')) {
            setShowMenu(false);
        }
    };

    React.useEffect(() => {
        if (showMenu) {
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }
    }, [showMenu]);

    return (
        <div style={style.container}>
            <div style={style.invoiceInfo}>
                <div style={style.invoiceId}>
                    {invoice?.id ? `Factura Num: ${invoice.docNumber}` : ``}
                </div>
                <div style={style.invoiceStatus}>
                    {invoice?.docNumber && (
                        <>
                            <span style={{ marginLeft: '8px', color: '#666' }}>
                                • Total: {invoice.subtotal}€
                            </span>
                            <span style={{ marginLeft: '8px', color: '#666' }}>
                                • Total (con iva): {invoice.total}€
                            </span>
                        </>
                    )}
                </div>
            </div>
            <div style={style.invoiceStatus}>
                {getStatusBadge(invoice?.status)}

            </div>
            {!buttonHidden && (
                <div className="invoice-menu-container" style={{ position: 'relative' }}>
                    <button
                        style={style.menuButton}
                        onClick={() => setShowMenu(!showMenu)}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = style.menuButtonHover.backgroundColor;
                            e.target.style.color = style.menuButtonHover.color;
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#666666';
                        }}
                    >
                        ⋮
                    </button>

                    {showMenu && (
                        <div style={style.dropdown}>
                            {menuOptions.map((option, index) => (
                                <div
                                    key={option.id}
                                    style={{
                                        ...style.dropdownItem,
                                        ...(index === menuOptions.length - 1 ? style.dropdownItemLast : {})
                                    }}
                                    onClick={() => handleMenuItemClick(option)}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = style.dropdownItemHover.backgroundColor;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>{option.icon}</span>
                                    {option.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InvoiceCell; 